import script from "./ButtonPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonPrimary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonPrimary.vue?vue&type=style&index=0&id=4de2aafa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4de2aafa"]])

export default __exports__